import { BusinessSlug } from '@workspace/data-types';
import { ApiCaller } from '../../api-caller.service';
import { EtxeConnector } from './etxe/etxe.connector';

export class BusinessConnector {
  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  etxe = () =>
    new EtxeConnector(this.apiCaller, `${this.prefix ? this.prefix + '/' : ''}${BusinessSlug.ETXE}`);
}
